import React from 'react';

const Intro = () => {
  return (
    <section id="intro" className="relative min-h-screen flex items-center justify-center bg-gray-900">
      <div className="absolute inset-0">
        <img 
          src="https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1200&h=800&fit=crop" 
          alt="" 
          className="w-full h-full object-cover opacity-60"
        />
      </div>
      
      <div className="relative z-10 text-center text-white px-4 sm:px-6 lg:px-8">
        <p className="text-lg mb-4">Welcome to</p>
        <h1 className="text-4xl md:text-6xl font-bold mb-8">
          Pixel Perfect <br />
          Fashion Photography <br />
          Gallery
        </h1>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="#about" className="bg-white text-gray-900 px-8 py-3 rounded-lg hover:bg-gray-100 transition-colors">
            Discover More
          </a>
          <a href="#footer" className="border-2 border-white text-white px-8 py-3 rounded-lg hover:bg-white hover:text-gray-900 transition-colors">
            Get In Touch
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <a href="#about" className="text-white animate-bounce">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M11.178 19.569a.998.998 0 0 0 1.644 0l9-13A.999.999 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13z"></path>
          </svg>
        </a>
      </div>
    </section>
  );
};

export default Intro;